<app-page-shell [title]="'settings_title' | translate" [description]="'settings_desc' | translate">
  <div class="flex flex-col gap-6">
    <!-- TabBar -->
    <div class="mb-4">
      <app-tabs [items]="tabs" [activeValue]="activeTab()" (activeValueChange)="setActiveTab($event)">
      </app-tabs>
    </div>

    <!-- Tab Content Container -->
    <div class="bg-white rounded-3xl p-8 shadow-sm border border-slate-100 min-h-[600px]">

      <!-- Profile Tab -->
      <app-profile-tab *ngIf="activeTab() === 'profile'"></app-profile-tab>

      <!-- Executables Tab -->
      <app-executables-tab *ngIf="activeTab() === 'executables'"></app-executables-tab>

      <!-- Imaging (RX) Tab -->
      <app-imaging-tab *ngIf="activeTab() === 'imaging'"></app-imaging-tab>

      <!-- Security Tab -->
      <!-- <app-security-tab *ngIf="activeTab() === 'security'"></app-security-tab> -->
    </div>
  </div>
</app-page-shell>
